module.exports = [{
      plugin: require('../node_modules/gatsby-omni-font-loader/gatsby-browser.js'),
      options: {"plugins":[],"enableListener":true,"preconnect":["https://fonts.googleapis.com","https://fonts.gstatic.com"],"web":[{"name":"Source Serif Pro","file":"https://fonts.googleapis.com/css2?family=Source+Serif+Pro&display=swap"},{"name":"Source Code Pro","file":"https://fonts.googleapis.com/css2?family=Source+Code+Pro&display=swap"}]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
